import { render, staticRenderFns } from "./labelingindex.vue?vue&type=template&id=5a4c90cd&scoped=true&"
import script from "./labelingindex.vue?vue&type=script&lang=js&"
export * from "./labelingindex.vue?vue&type=script&lang=js&"
import style0 from "./labelingindex.vue?vue&type=style&index=0&id=5a4c90cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c90cd",
  null
  
)

export default component.exports